import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import { checkPiAnswer, pick, renderPiAnswer, renderPiUserAnswer, SolidPiInput } from "../commonSolidPi";

export function generateTask() {
  const r = pick([3, 6, 9]);
  const k = (4 * r * r * r) / 3;
  return { type: "SphereVolumeTask", data: { r, k, numeric: k * Math.PI } };
}

export function renderTask({ data }) {
  return (
    <div style={{ marginBottom: 12 }}>
      Oblicz objętość kuli o promieniu <InlineMath math={`${data.r}`} />.
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return <SolidPiInput value={userAnswer} onChange={onChange} disabled={disabled} label="V" />;
}

export function checkAnswer({ data }, userAnswer) {
  return checkPiAnswer(data.numeric, userAnswer);
}

export function renderAnswer({ data }) {
  return renderPiAnswer("V", data.k);
}

export function renderUserAnswer(userAnswer) {
  return renderPiUserAnswer(userAnswer, "V");
}

export function renderExplanation({ data }) {
  const { r, k } = data;
  return (
    <div style={{ display: "grid", rowGap: 8 }}>
      <p><strong>Krok 1.</strong> Korzystamy ze wzoru na objętość kuli.</p>
      <BlockMath math={`V=\\frac{4}{3}\\pi r^3`} />
      <p><strong>Krok 2.</strong> Podstawiamy promień.</p>
      <BlockMath math={`V=\\frac{4}{3}\\pi\\cdot ${r}^3=${k}\\pi`} />
      <p><strong>Odpowiedź:</strong> <InlineMath math={`V=${k}\\pi`} />.</p>
    </div>
  );
}
